// Home visit request API utilities

export const acceptHomeVisitRequest = async (requestId: any, timeData: any, url: string, token: string | null) => {
    const response = await fetch(url + 'admin/home-visit-requests/accept', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            requestId: Number(requestId),
            definitiveArrivalTime: timeData.definitiveArrivalTime,
            startTimeSlot: timeData.startTimeSlot,
            endTimeSlot: timeData.endTimeSlot
        })
    });

    if (!response.ok) {
        throw new Error('Het accepteren van de aanvraag is mislukt');
    }

    return response;
};

export const createEBoekhoudenRelation = async (requestId: any, requestData: any, url: string, token: string | null) => {
    const response = await fetch(url + 'admin/home-visit-requests/create-relation', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            id: Number(requestId),
            firstName: requestData.FirstName,
            lastName: requestData.LastName,
            email: requestData.Email,
            address: requestData.Address,
            zipCode: requestData.ZipCode,
            city: requestData.City
        })
    });

    if (!response.ok) {
        throw new Error('Het aanmaken van de relatie in e-boekhouden is mislukt');
    }

    return response;
};

export const acceptAndCreateRelation = async (requestId: any, timeData: any, requestData: any, url: string, token: string | null) => {
    // The backend "accept" endpoint already creates (or updates) the e-boekhouden
    // relation and stores its RelationId. Calling createEBoekhoudenRelation here as
    // well caused the relation API call to be sent out twice, so we only accept here.
    await acceptHomeVisitRequest(requestId, timeData, url, token);
};

export const declineHomeVisitRequest = async (requestId: any, url: string, token: string | null) => {
    const response = await fetch(url + 'admin/home-visit-requests/decline', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            ID: Number(requestId)
        })
    });

    if (!response.ok) {
        throw new Error('Het afwijzen van de aanvraag is mislukt');
    }

    return response;
};
